import React from 'react';
import {Route, Link} from 'react-router-dom';

import "./Header.scss";

const Header : React.FC = () => {

    return (
    <header className="header">
    	<nav className="header__nav">
    		<Link to="/" className="logo">
    			<img
                    src={`${process.env.PUBLIC_URL}/assets/images/me-icon.png`}
                    alt="max_hha"
                />
    		</Link>
    		<CustomLink to="/about" >About</CustomLink>
    		<CustomLink to="/projects" >Projects</CustomLink>
    	</nav>
    </header>
    );
}

const CustomLink : React.FC<{to: string}> = ({to, children}) => (
    <Route
        path={to}
        children={({match}) => (
            <Link
                to={to}
                className={`link ${match ? "link_active" : ""}`}
            >{children}</Link>
        )}
    />
);

export default Header;
